import {
  useQuery
} from '@tanstack/vue-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  BackendErrorEntity,
  OnboardingSessionCompanyEntity
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiGetSelfOnboardingSessionCompany = (
    
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      
      
      return fetchApiInstance<OnboardingSessionCompanyEntity>(
      {url: `/onboardingSessionCompany`, method: 'GET'
    },
      options);
    }
  

export const getApiGetSelfOnboardingSessionCompanyQueryKey = () => {
    return ['onboardingSessionCompany'] as const;
    }

    
export const getApiGetSelfOnboardingSessionCompanyQueryOptions = <TData = Awaited<ReturnType<typeof apiGetSelfOnboardingSessionCompany>>, TError = ErrorType<BackendErrorEntity>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetSelfOnboardingSessionCompany>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetSelfOnboardingSessionCompanyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetSelfOnboardingSessionCompany>>> = () => apiGetSelfOnboardingSessionCompany(requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetSelfOnboardingSessionCompany>>, TError, TData> 
}

export type ApiGetSelfOnboardingSessionCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetSelfOnboardingSessionCompany>>>
export type ApiGetSelfOnboardingSessionCompanyQueryError = ErrorType<BackendErrorEntity>



export function useApiGetSelfOnboardingSessionCompany<TData = Awaited<ReturnType<typeof apiGetSelfOnboardingSessionCompany>>, TError = ErrorType<BackendErrorEntity>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetSelfOnboardingSessionCompany>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetSelfOnboardingSessionCompanyQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



